export default __webpack_public_path__ + "static/media/locked.5effa29d.svg";